// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xm-1";
export var printerIcon = "_xm-0";